import { useSelector } from 'react-redux'

export default function useActiveTableIdFinder(tableId) {
    const activeGames = useSelector((state) => state.gameTable.games);

    let tempTableId = null;
    let gameData = null;
    if (activeGames && typeof activeGames === 'object') {
        for (const [key, game] of Object.entries(activeGames)) {
            if (game.tableId === tableId) {
                tempTableId = key;
                gameData = game;
                break;
            }
        }
    }
    const isActive = !!gameData;

    return {
        isTableActive: isActive,
        tempTableId: tempTableId,
    };
}